/* Compact page navigation that stays below the storefront header. */
(function () {
  function init() {
    document.querySelectorAll('.hc-page-jumps, .hc-resource-nav, .hc-home-jump').forEach(function (nav) {
      if (nav.dataset.stickyReady) return;
      nav.dataset.stickyReady = 'true';
      var slot = document.createElement('div');
      slot.className = 'hc-page-jumps-slot';
      nav.parentNode.insertBefore(slot, nav);
      slot.appendChild(nav);
      var naturalHeight = 0;
      var queued = false;
      function update() {
        queued = false;
        if (!nav.isConnected) return;
        var header = document.getElementById('shopify-section-header');
        var headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
        if (!nav.classList.contains('is-stuck')) {
          naturalHeight = slot.getBoundingClientRect().height;
        }
        var stuck = slot.getBoundingClientRect().top <= headerBottom;
        if (stuck) {
          slot.style.height = naturalHeight + 'px';
          nav.classList.add('is-stuck');
          nav.style.setProperty('--hc-jump-top', headerBottom + 'px');
        } else {
          nav.classList.remove('is-stuck');
          slot.style.height = '';
          naturalHeight = slot.getBoundingClientRect().height;
        }
        document.documentElement.style.setProperty('--hc-section-nav-offset',
          (headerBottom + nav.getBoundingClientRect().height + 20) + 'px');
      }
      function requestUpdate() {
        if (queued) return;
        queued = true;
        requestAnimationFrame(update);
      }
      function resized() {
        nav.classList.remove('is-stuck');
        slot.style.height = '';
        naturalHeight = slot.getBoundingClientRect().height;
        requestUpdate();
      }
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', resized, { passive: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(resized);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

